import React, { useState } from "react";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";

export function ChangePasswordModal({ open, onClose, userEmail }) {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Reautenticación y cambio de password
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: userEmail,
      password: currentPassword,
    });

    if (signInError) {
      toast({
        title: "Error",
        description: "La contraseña actual es incorrecta.",
        variant: "destructive",
      });
      setIsSubmitting(false);
      return;
    }

    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) {
      setIsSubmitting(false);
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
      return;
    }

    // Actualizar también la contraseña en public.users para mantener sincronización
    const { error: updateError } = await supabase
      .from('users')
      .update({ password: newPassword })
      .eq('username', userEmail);

    setIsSubmitting(false);

    if (updateError) {
      toast({
        title: "Advertencia",
        description: "La contraseña se cambió en Auth pero no se pudo actualizar en la base de datos. Contacta al administrador.",
        variant: "destructive",
      });
    } else {
      toast({
        title: "Contraseña cambiada",
        description: "Tu contraseña ha sido actualizada correctamente.",
      });
      onClose();
      setCurrentPassword("");
      setNewPassword("");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <form onSubmit={handleChangePassword} className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
        <h2 className="text-xl font-bold mb-4">Cambiar contraseña</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Contraseña actual</label>
          <Input
            type="password"
            required
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1">Nueva contraseña</label>
          <Input
            type="password"
            required
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Cambiando..." : "Cambiar"}
          </Button>
        </div>
      </form>
    </div>
  );
} 